import apiClient from './authService';

const adminService = {
  // ── Leads ──────────────────────────────────────────────────────────
  getLeads: async () => {
    const res = await apiClient.get('/api/leads');
    return res.data.leads || [];
  },

  getLeadStats: async () => {
    const res = await apiClient.get('/api/leads/stats');
    return res.data.stats;
  },

  inviteLead: async (leadId) => {
    const res = await apiClient.post(`/api/leads/${leadId}/invite`);
    return res.data;
  },

  resendInvite: async (leadId) => {
    const res = await apiClient.post(`/api/leads/${leadId}/resend-invite`);
    return res.data;
  },

  // ── Feature Flags ──────────────────────────────────────────────────
  getAllFlags: async () => {
    const res = await apiClient.get('/api/feature-flags');
    return res.data;
  },

  createFlag: async ({ key, name, description }) => {
    const res = await apiClient.post('/api/feature-flags', { key, name, description });
    return res.data;
  },

  toggleFlag: async (key) => {
    const res = await apiClient.patch(`/api/feature-flags/${key}/toggle`);
    return res.data;
  },

  addEmailToFlag: async (key, email) => {
    const res = await apiClient.post(`/api/feature-flags/${key}/emails`, { email });
    return res.data;
  },

  removeEmailFromFlag: async (key, email) => {
    const res = await apiClient.delete(`/api/feature-flags/${key}/emails/${encodeURIComponent(email)}`);
    return res.data;
  },

  addUserToFlag: async (key, userId) => {
    const res = await apiClient.post(`/api/feature-flags/${key}/users/${userId}`);
    return res.data;
  },

  removeUserFromFlag: async (key, userId) => {
    const res = await apiClient.delete(`/api/feature-flags/${key}/users/${userId}`);
    return res.data;
  },

  // ── Organisations ──────────────────────────────────────────────────
  getAllOrgs: async () => {
    const res = await apiClient.get('/api/organizations/admin/all');
    return res.data;
  },

  updateOrgPlan: async (orgId, { plan, status }) => {
    const res = await apiClient.put(`/api/organizations/admin/${orgId}/plan`, { plan, status });
    return res.data;
  },
};

export default adminService;
